import {Helmet} from '@dr.pogodin/react-helmet';
import {match} from 'ts-pattern';

import {always} from 'ramda';
import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {employeeRoutes, testIds} from '@dms/routes';
import {DmsDataGrid, Main, useIsLicenceEnabled} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function EmployeeOverview() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    if (actionKey === 'redirectDetail') {
      const id = isArray(rowId) ? rowId[0] : rowId;

      navigate(composePath(employeeRoutes.detail, {params: {id}, queryParams: sourceSearchParams}));
    }
  };

  const {isSalesModuleEnabled, isWorkshopModuleEnabled} = useIsLicenceEnabled();

  const gridCode = match([isSalesModuleEnabled, isWorkshopModuleEnabled])
    .with([true, false], always('employees-sales'))
    .with([false, true], always('employees-after-sales'))
    .otherwise(always('employees'));

  return (
    <>
      <Helmet title={i18n.t('page.employees.title')} />
      <Main
        isFullHeight
        actions={[
          {
            type: 'button',
            title: i18n.t('entity.employee.actions.newEmployee'),
            onClick: () => navigate(employeeRoutes.createEmployee),
          },
        ]}
        heading={i18n.t('page.employees.title')}
        data-testid={testIds.employee.overview('overview')}
      >
        <DmsDataGrid
          gridCode={gridCode}
          actionCallback={actionCallback}
          data-testid={testIds.employee.overview('overview')}
        />
      </Main>
    </>
  );
}
